import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import FuzzbugSprites from '../sprites/FuzzbugSprites';
import gameData from '../gameData';

export default class PlayerFuzzbug extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   * @param {number} x 
   * @param {number} y 
   */
  constructor(scene, x, y) {
    super(scene);

    this.sceneX = x;
    this.sceneY = y;

    this.canHitGround = true;
    this.canHitPlatforms = true;

    this.freeJumping = true;
    this.lockedHorizontal = false;

    this.isFloating = false;
    this.jumpPower = 1;
    this.floatGravity = 600;
    this.floatPower = 0.8;
    this.floatDrag = 200;

    this.baseDrag = 200;
    this.lift = 0;

    this.isPartying = false;
    this.isGoofy = false;

    this.lastFuzzOffset = { x: 0, y: 0 };

    this.setup();

    this.scene.events.on(Phaser.Scenes.Events.UPDATE, this.update, this);
    this.once(Phaser.GameObjects.Events.DESTROY, () => this.scene.events.off(Phaser.Scenes.Events.UPDATE, this.update, this));
  }

  setup () {
    this.floatSound = ABCyaPhaser.Audio.createSound(this.scene);
    this.once(Phaser.GameObjects.Events.DESTROY, () => this.floatSound.destroy());
    this.usingPhysics = true;

    this.fakeFuzz = this.scene.add.container(this.sceneX, this.sceneY);
    this.feet = this.scene.add.container(this.sceneX, this.sceneY);
    this.add([this.fakeFuzz, this.feet]);

    const frameInfoBody = this.scene.textures.getFrame(ABCyaPhaser.Images.DEFAULT_ATLAS, 'Body_Orange');
    const frameInfoFeet = this.scene.textures.getFrame(ABCyaPhaser.Images.DEFAULT_ATLAS, 'Feet_Together');

    this.spriteParts = new FuzzbugSprites(this.scene, this.fakeFuzz, frameInfoBody, frameInfoFeet);

    this.scene.physics.add.existing(this.fakeFuzz);
    this.fakeFuzz.body.setCircle(82 / 2, -frameInfoBody.width / 2 + 5, -frameInfoBody.width / 2 + 5);

    this.scene.physics.add.existing(this.feet);
    this.feet.body.setSize(frameInfoFeet.width, frameInfoFeet.height * 0.75);

    this.baselineGravity = gameData.config.playerGravity;
    this.fakeFuzz.body.gravity.y = 0;
    this.feet.body.setGravityY(this.baselineGravity);
    this.feet.body.setVelocityY(300);
    this.feet.body.setDragY(this.baseDrag);
    this.lift = 0;

    this.fakeFuzz.body.collideWorldBounds = true;
    this.feet.body.collideWorldBounds = true;

    this.bringToTop(this.fakeFuzz);

    this.fakeFuzzOffset = { x: -frameInfoBody.width / 2 + frameInfoFeet.width * 0.75 + 2, y: (-frameInfoBody.height / 2) - (frameInfoFeet.height * 0.75 + 5) };
    this.spriteParts.hostSprite.angle = 0;
  }

  toggleUsingPhysics(disable) {
    if (this.usingPhysics === false && disable === true) {
      this.feet.body.x = this.fakeFuzz.x + this.lastFuzzOffset.x;
      this.feet.body.y = this.fakeFuzz.y + this.lastFuzzOffset.y;
    }
    this.fakeFuzz.body.moves = disable;
    this.feet.body.moves = disable;
    this.usingPhysics = disable;
  }

  setLiftDrag(lift = 0, drag = this.baseDrag) {
    this.feet.body.lift = lift;
    this.feet.body.setDragY(drag);
  }

  introJumpToPoint(destX, destY, callback, callbackContext, jumpOffset = -900, time = 1000) {
    this.feet.body.setVelocity(0);
    this.lastFuzzOffset.x = 0;
    this.lastFuzzOffset.y = 0;
    const dx = destX;
    const dy = destY;

    const path = new Phaser.Curves.QuadraticBezier(new Phaser.Math.Vector2(this.fakeFuzz.x, this.fakeFuzz.y), new Phaser.Math.Vector2(this.fakeFuzz.x, this.fakeFuzz.y + jumpOffset), new Phaser.Math.Vector2(dx, dy));
    ABCyaPhaser.Tweens.addPathTween(this.fakeFuzz, path, time, null, Phaser.Math.Easing.Linear, callback.bind(callbackContext));
  }

  collectHat(value) {
    if (this.isGoofy) {
      if (this.goofyTween) {
        this.goofyTween.stop();
      }
      this.spriteParts.hostSprite.angle = 0;
    }
    this.isGoofy = false;
    this.isPartying = false;
    this.isFloating = false;

    this.jumpPower = 1;
    this.setLiftDrag(0, this.baseDrag);
    this.setPlayerGravity(this.baselineGravity);

    this.spriteParts.showHat(value);
    if (value.texture === 'pinwheel_hat') {
      this.isFloating = true;
      this.setPlayerGravity(900);
      this.jumpPower = 1;
      this.setLiftDrag(300, 380);
    }
    else if (value.texture === 'party_hat') {
      this.isPartying = true;
    }
    else if (value.texture === 'jester_hat') {
      this.isGoofy = true;
    }
  }

  setFreeJumping() {
    this.freeJumping = true;
    if (this.isFloating === true) {
      this.setPlayerGravity(this.floatGravity);
      this.jumpPower = this.floatPower;
      this.setLiftDrag(this.floatDrag , this.floatDrag);
    }
    else {
      this.jumpPower = 1;
      this.setLiftDrag();
      this.setPlayerGravity(this.baselineGravity);
    }
  }

  jump(value) {
    if (this.floatSound.isPlaying) {
      this.floatSound.stop();
    }
    this.feet.body.setVelocityY(value * this.jumpPower - this.lift);
    this.jumping = true;
    if (value !== 0) this.spriteParts.doJump(this.freeJumping);
  }

  checkForHatEffect() {
    if (this.isGoofy) {
      this.doGoofy(this.getVelX() < 0);
    }
  }

  doGoofy(movingLeft) {
    if (this.goofyTween) {
      this.goofyTween.stop();

    }
    const mod = movingLeft ? 360 : -360;
    this.spriteParts.hostSprite.angle = 0;
    this.goofyTween = ABCyaPhaser.Tweens.addTween(this.spriteParts.hostSprite, 400, { angle: mod }, Phaser.Math.Easing.Linear);
  }

  setLift(value) {
    this.lift = value;
  }

  capClimb() {
    if (this.feet.body.velocity.y < -800) {
      this.feet.body.drag.y = 800;
      this.feet.body.gravity.y = this.baselineGravity * 1.5;
    }
  }

  backToNormalClimbSettings() {
    if (this.isFloating === true) {
      this.setPlayerGravity(this.floatGravity);
      this.jumpPower = this.floatPower;
      this.setLiftDrag(this.floatDrag , this.floatDrag);
    }
    else {
      this.setLiftDrag(0 , this.baseDrag);
      this.feet.body.gravity.y = this.baselineGravity;
      this.jumpPower = 1;
    }
  }

  setVelX(value) {
    this.feet.body.velocity.x = value;
  }

  setVelY(value) {
    this.feet.body.velocity.y = value;
  }

  setPlayerGravity(value) {
    this.feet.body.gravity.y = value;
  }

  pushToPrevY(value) {
    if (this.feet.body.y < value) this.feet.body.y = value;
  }

  getVelY() {
    return this.feet.body.velocity.y;
  }

  getVelX() {
    return this.feet.body.velocity.x;
  }

  getBodyY() {
    return this.feet.body.y;
  }

  getPrevBodyY() {
    return this.feet.body.prev.y;
  }

  zeroFuzzMovement() {
    this.feet.body.velocity.y = 0;
    this.feet.body.velocity.x = 0;
    this.feet.body.gravity.y = 0;
    this.lift = 0;
  }

  updateManualPosition(x,y) {
    this.fakeFuzz.body.moves = false;
    this.feet.body.moves = false;
    this.fakeFuzz.active = true;
    this.fakeFuzz.visible = true;

    this.feet.setPosition(x, y);
    this.feet.active = true;
    this.feet.visible = true;
    this.feet.body.reset(x,y);

    this.fakeFuzz.body.reset(this.feet.x + this.fakeFuzzOffset.x, this.feet.y + this.fakeFuzzOffset.y);
    this.feet.body.moves = true;
    this.fakeFuzz.body.moves = true;
  }

  update (time, dt) {
    this.fakeFuzz.body.x = this.feet.body.x + this.fakeFuzzOffset.x;
    this.fakeFuzz.body.y = this.feet.body.y + this.fakeFuzzOffset.y;

    if (this.jumping === true) {
      if (this.getVelY() > 0) {
        if (this.jumping && this.isFloating) {
          if (!this.floatSound.isPlaying) {
            ABCyaPhaser.Audio.playSound('Propellor_Hat', this.floatSound);
          }
        }
        this.jumping = false;
        if (this.freeJumping) this.spriteParts.startDown();
      }
      else if (this.getVelY() < -500) {
        this.spriteParts.startBlow();
      }
      else {
        this.spriteParts.stopBlow();
      }
    }
    if (this.lockedHorizontal) {
      this.feet.body.velocity.x = 0;
    }
    this.spriteParts.update(dt / 1000);
  }
}